'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dCredentials$0024 from "./presto.-Credentials$.js";
var $p;
/** @constructor */
function $c_Lpresto_CredentialTables$$anon$29() {
}
export { $c_Lpresto_CredentialTables$$anon$29 as $c_Lpresto_CredentialTables$$anon$29 };
$p = $c_Lpresto_CredentialTables$$anon$29.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_CredentialTables$$anon$29;
/** @constructor */
function $h_Lpresto_CredentialTables$$anon$29() {
}
export { $h_Lpresto_CredentialTables$$anon$29 as $h_Lpresto_CredentialTables$$anon$29 };
$h_Lpresto_CredentialTables$$anon$29.prototype = $p;
$p.aR = (function(item) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().a, $j_presto$002e$002dCredentials$0024.$m_Lpresto_Credentials$().ae7(item), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$().m);
});
var $d_Lpresto_CredentialTables$$anon$29 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_CredentialTables$$anon$29, "presto.CredentialTables$$anon$29", ({
  Fq: 1,
  A: 1
}));
export { $d_Lpresto_CredentialTables$$anon$29 as $d_Lpresto_CredentialTables$$anon$29 };
//# sourceMappingURL=presto.-Credential-Tables$$anon$29.js.map
